import styled, { css } from 'styled-components';
import colors from '../../../../helpers/colors';
import fonts from '../../../../helpers/fonts';
import mediaQuery from '../../../../helpers/mediaQuery';
import spacing from '../../../../helpers/spacing';

export type NavItemProps = {
  active?: boolean;
};

export const NavItemMobileLink = styled.a<NavItemProps>`
  display: block;
  text-decoration: none;
  text-align: left;

  border-left: solid 2px ${colors.neutral05};
  padding: ${spacing(1.5)} ${spacing(3)};

  &:first-child {
    padding-top: ${spacing(1)};
  }

  ${mediaQuery.tabletPortrait`
    &:first-child {
      padding-top: ${spacing(2)};
    }
  `}

  &:last-child {
    padding-bottom: 0;
  }

  ${({ active }) =>
    active &&
    css`
      border-color: ${colors.navigationHighlight};
      ${fonts.paragraphLarge}
    `}

  ${({ active }) => (active ? fonts.paragraphLarge : fonts.paragraph)}
  
  & {
    color: ${({ active }) => (active ? colors.neutral01 : colors.neutral02)};
  }
`;
